import React, { useState, useEffect } from 'react';
import { Drawer, Form, Input, Button, Select, message, Card,Spin } from 'antd';
import apiService from '../Components/apiService'; // Import your ApiService class
import { BASE_URL } from '../Components/Constant';
import DynamicPicklistComponent from '../Components/MultiSelectPicklistComponent';
import CustomDrawer from '../Components/CustomDrawer';


const { Option } = Select;

const CreateRelatedListDrawer = ({ visible, onClose, onAddRelatedList, parentObjectName, editingRelatedList }) => {
  const [form] = Form.useForm();
  const [parentObjects, setParentObjects] = useState([]);
  const [childObjectFields, setChildObjectFields] = useState([]);
  const [selectedChild, setSelectedChild] = useState('');
  const [selectedFields, setSelectedFields] = useState([]);
  const [lookupFields, setLookupFields] = useState([]); // New state for lookup fields
  const [objectName,setObjectName]=useState(parentObjectName);
  const [loading,setLoading]=useState(false);

  // Fetch parent objects
  useEffect(() => {
    const fetchParentObjects = async () => {
      const api = new apiService(`${BASE_URL}/mt_objects`, {}, 'GET');
      try {
        const res = await api.makeCall();
        setParentObjects(res);
      } catch (error) {
      }
    };

    fetchParentObjects();
  }, []);

  // Pre-populate the form when editing a related list
  useEffect(() => {
    if (editingRelatedList) {
      form.setFieldsValue({
        relatedListName: editingRelatedList?.related_list_name,
        parentObject: editingRelatedList?.parent_object_name,
        childObject: editingRelatedList?.child_object_name,
        fieldsToDisplay: editingRelatedList?.fields_to_display,
        fieldapiname: editingRelatedList?.field_api_name,
        listOrder: editingRelatedList?.order
      });
      setSelectedChild(editingRelatedList?.child_object_name);
      setSelectedFields(editingRelatedList?.fields_to_display || []);
    } else {
      form.resetFields();
      form.setFieldsValue({ parentObject: parentObjectName }); // Set the parent object when creating a new related list
    }
  }, [editingRelatedList, parentObjectName, form]);

  // Fetch fields for the selected child object
  useEffect(() => {
    if (selectedChild) {
      const fetchChildObjectFields = async () => {
        const api = new apiService(`${BASE_URL}/mt_fields/object/${selectedChild}`, {}, 'GET');
        try {
          const res = await api.makeCall();
          setChildObjectFields(res
            .filter((field) => field?.name !== 'recordCount')
          );
 
          const lookupFieldsFiltered = res.filter(
            (field) => field?.type === 'lookup' && field?.parent_object_name === parentObjectName
          );
          setLookupFields(lookupFieldsFiltered);
        } catch (error) {
        }
      };
      fetchChildObjectFields();
    } else {
      setChildObjectFields([]);
    }
  }, [selectedChild]);

  // Handle child object selection
  const handleChildObjectChange = (value) => {
    setSelectedChild(value);
    setSelectedFields([]); // Reset selected fields when a new child object is chosen
  };

  // Handle field selection with a maximum of 7 fields
  const handleFieldChange = async (value) => {
    // if (value.length > 7) {
    //   //message.error('You can select up to 7 fields.');
    //   return;
    // }
    setSelectedFields(value);
  };

  // Submit form handler
  const handleFinish = async (values, saveAndNew = false) => {
    const { relatedListName, fieldapiname, listOrder } = values;
    if (!relatedListName  || !selectedChild) {
      message.error('Please complete all required fields.');
      return;
    }

    const data = {
      parent_object_name: parentObjectName,
      child_object_name: selectedChild,
      related_list_name: relatedListName,
      fields_to_display: selectedFields,
      field_api_name: fieldapiname,
      order: listOrder
    };

    try {
      setLoading(true);
      const apiServiceForTab = new apiService(
        `${BASE_URL}/create_related_list`,
        { 'Content-Type': 'application/json' },
        'POST',
        data
      );

      await apiServiceForTab.makeCall();
      message.success('Related list created successfully!');
      // setSelectedFields([]);
      // form.resetFields();
      // form.setFieldsValue({ parentObject: parentObjectName ,fieldsToDisplay:[]});  // Explicitly set the parentObject field value

      // setObjectName(parentObjectName);  
      // onClose(); // Close the drawer after successful creation
      if (!saveAndNew) {
        form.resetFields();
        form.setFieldsValue({ parentObject: parentObjectName ,fieldsToDisplay:[]});  // Explicitly set the parentObject field value
        setObjectName(parentObjectName); 
        setSelectedFields([]); 
        onClose(); // Close the drawer for regular save
      } else {
        form.resetFields(); // Reset the form for new object creation
        form.setFieldsValue({ parentObject: parentObjectName ,fieldsToDisplay:[]});  // Explicitly set the parentObject field value
        setObjectName(parentObjectName); 
        setSelectedFields([]);
      }
      //onAddRelatedList(values); // Callback to refresh related lists
    } catch (error) {
  
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to create new related list due to an unknown error';
      message.error(errorMessage);
    }finally{
      setLoading(false);
    }
  };
 

  return (
   

      <CustomDrawer
            title={editingRelatedList ? "Edit Related List" : "Create Related List"}
            visible={visible}
      onClose={!loading ? onClose : null}
            closable={false}
            footer={
            <div style={{ display: "flex", justifyContent: "space-between" , padding: '8px' }}>
                <Button onClick={onClose} >Cancel</Button>
                 <div>
          <Button 
           style={{
              marginRight: '16px',
            }} 
            onClick={() => {
            form.validateFields().then((values) => {
              handleFinish(values, true); // Pass a flag to differentiate Save & New
            });
          }}  
          type="primary">Save & New</Button>
                <Button type="primary" form="createRelatedListForm" htmlType="submit" >
                Save
                </Button>
                </div>
            </div>
            }
        >
          
          <Spin spinning={loading}>
        <Form layout="vertical" id="createRelatedListForm" form={form} onFinish={handleFinish}>
          <Form.Item
            name="relatedListName"
            label="Related List Name"
            rules={[{ required: true, message: 'Please enter the related list name' }]}
          >
            <Input placeholder="Enter related list name" />
          </Form.Item>

          <Form.Item
            name="parentObject"
            label="Parent Object"
            value={objectName}
            rules={[{ required: true, message: 'Please select a parent object' }]}
          >
            <Input  disabled value={objectName}>
            </Input>
          </Form.Item>

          <Form.Item
            name="childObject"
            label="Child Object"
            rules={[{ required: true, message: 'Please select a child object' }]}
          >
            <Select placeholder="Select child object" onChange={handleChildObjectChange} value={selectedChild}>
              {parentObjects.map(obj => (
                <Option key={obj.id} value={obj.name}>{obj.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {selectedChild && (
            <>
              <Form.Item
                name="fieldsToDisplay"
                label="Fields to Display"
                rules={[{ required: true, message: 'Please select at least one field' }]}
              > 
                
                <DynamicPicklistComponent
              onChange={handleFieldChange}
              isSelect={true}
              selectedFields={selectedFields}
              selectOptions={childObjectFields}
            >

            </DynamicPicklistComponent>
              </Form.Item>

              <Form.Item
                name="fieldapiname"
                label="Lookup Name"
                rules={[{ required: true, message: 'Please select a lookup field' }]}
              >
                <Select placeholder="Select a lookup field">
                  {lookupFields.map(field => (
                    <Option key={field.name} value={field.name}>{field.label}</Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="listOrder"
                label="List Order"
                rules={[{ required: true, message: 'Please enter the list order' }]}
              >
                <Input placeholder="Enter list order" />
              </Form.Item>
            </>

          )}
        </Form>
        </Spin>
     
    </CustomDrawer>
  );
};

export default CreateRelatedListDrawer;
